import React from "react";
import Logo from "../Components/Images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    signOut(auth).then(() => {
      navigate("/");
    });
  };

  return (
    <div className="adminHeader p-5 flex justify-between items-center bg-grey w-screen">
      <Link to="/dashboard">
        <img src={Logo} alt="Madhur Exports" />
      </Link>
      <div className="flex items-center gap-4">
        <Link to="/dashboard">
          <button>Home</button>
        </Link>
        <Link to="/dashboard/manageBlogs">
          <button>Blogs</button>
        </Link>
        <Link to="/dashboard/images">
          <button>Images</button>
        </Link>
        <button
          className="border rounded px-4 py-1 text-red-600 border-red-600 hover:bg-red-600 hover:text-white transition-colors"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default Header;
